var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.matches),function(input){return _c('mz-search-box',{key:input.id,attrs:{"input":input,"query-param":_vm.queryParam,"search-url":_vm.searchUrl,"placement":_vm.placement},on:{"change":_vm.onChange}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }